/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Import_Duty_CostInputs */

const en_field_import_duty_cost = /** @type {(inputs: Field_Import_Duty_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import duty`)
};

/**
* | output |
* | --- |
* | "Import duty" |
*
* @param {Field_Import_Duty_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_import_duty_cost = /** @type {((inputs?: Field_Import_Duty_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Import_Duty_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_import_duty_cost(inputs)
});